module.exports = __webpack_public_path__ + "static/img/time_line.fdb72fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/time_line.png
// module id = 5f2L
// module chunks = 1